import { articleComments } from '@/mocks/article';

export default function CommentSection() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-accent-600 font-medium">网友讨论</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            吃瓜群众热议
          </h2>
          <p className="text-sm text-foreground-500">快来一起参与讨论，发表你的看法</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleComments.map((comment) => (
            <div
              key={comment.id}
              className="bg-white rounded-lg p-5 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-200'}`}></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 flex-1">
                {comment.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-100">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.username}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-950">{comment.username}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button className="inline-flex items-center gap-2 bg-foreground-950 text-white px-8 py-3 rounded-full text-sm font-medium whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer">
            查看更多评论
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-line text-xs"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}